import { FC } from 'react'
import { Modal } from 'antd'

import { TargetsModalHeader } from './TargetsModalHeader'
import { TargetsModalFooter } from './TargetsModalFooter'
import { TargetsModalContent } from './TargetsModalContent'
import { useTargetsModalStore } from './TargetsModalStore'

export const TargetsModal: FC = () => {
  const isModalOpened = useTargetsModalStore((state) => state.isModalOpened)

  return (
    <Modal
      title={<TargetsModalHeader />}
      visible={isModalOpened}
      closable={false}
      footer={<TargetsModalFooter />}
      destroyOnClose={true}
      className="per-modal per-modal--large"
    >
      <TargetsModalContent />
    </Modal>
  )
}
